export default __webpack_public_path__ + "static/media/PV-HOODIE-FRONT-DETAIL.50f86df9.png";